export { logoSizes, LogoSize } from './logo';
